const getGlobalState = (state, key) => (Array.isArray(state.feedSettings[key]) ? state.feedSettings[key].slice(0) : state.feedSettings[key]);

export const feedSettings = (state) => getGlobalState(state, 'feedSettings');
export const tennisFeedSettings = (state) => getGlobalState(state, 'tennisFeedSettings');
